// Native Run A, Part 3 (docs/NATIVE_RUN_A_SPEC.md) — the two build-time defines, read once.
//
// Deliberately dependency-free, like lib/content.js: content.js and speech.js import this to
// address the server, and neither may pull api.js in behind it. The photo-grant machinery,
// which does need api.js, lives in lib/origin.js and re-exports everything here, so app code
// imports origin.js and only the two dependency-free modules import this file directly.
//
//   __LB_NATIVE__      boolean   the web build defines false; scripts/build-native.mjs true
//   __LB_API_ORIGIN__  string    the web build defines ""; native the host it is built for
//
// Read through typeof guards so a bundle built WITHOUT the defines (the jsdom harnesses, the
// check scripts) is the web build: identity for everything below. scripts/check-native.mjs
// section 7 holds that contract.
export const IS_NATIVE = typeof __LB_NATIVE__ !== "undefined" && __LB_NATIVE__ === true;
export const API_ORIGIN = IS_NATIVE && typeof __LB_API_ORIGIN__ === "string" ? __LB_API_ORIGIN__.replace(/\/+$/, "") : "";

// A server-relative path, as a URL this build can fetch. The web build returns it unchanged.
export function apiUrl(path) {
  return API_ORIGIN + path;
}

// The web origin to put in links people share, scan or open: the QR deep links, the referral
// and homework share links, the readable join link, and the public pages. Native builds name
// the host they were built for; the web build is the page's own origin, as before.
export function publicOrigin() {
  if (IS_NATIVE) return API_ORIGIN;
  return typeof window !== "undefined" ? window.location.origin : "https://littlebankers.uk";
}

// An href for a public web page (/terms, /privacy, /help). Relative on the web, exactly as it
// was; absolute in a native build, where a relative path would ask the local bundle for a
// page it does not hold, and the native bootstrap opens public-origin links in the system
// browser.
export function publicPageHref(path) {
  return IS_NATIVE ? API_ORIGIN + path : path;
}
